import getLocations from '@api/routes/locations-api/getLocations';
import * as templates from './templates';
import { mapStyles } from '../../utils/location-map';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

var Bunge = Bunge || {};

Bunge.LocationResults = (function($) {
    var ui = {};

    var searchParams = {
        pageNum: 1,
        searchTerm: '',
        allRegions: '',
        region: '',
        pageSize: 7,
        sites: '',
        facilityType: '',
        viewType: '',
    };

    const params = {
        region: 'region',
        allregions: 'allRegions',
        searchTerm: 'searchTerm',
        viewType: 'viewType',
        facilityType: 'facilityType',
    }

    const ViewTypes = {
        MapView: 'map',
        ListView: 'list',
    }

    const activeClassName = '-active';
    const activeClass = `.${activeClassName}`;

    var locations = [];

    let sitesType = $('[data-sites]').attr('data-sites');
    if (sitesType) {
        searchParams.sites = $('[data-sites]').attr('data-sites');
    }

    function cacheUI() {
        ui.$filter = $('[data-filtercontrol]');
        ui.$listingContainer = $('[data-region="locationResults"]');
        ui.$mapContainer = $('[data-region="mapContainer"]');
        ui.$mapFacility = $('[data-region="mapFacilityType"]');
        ui.$mapClearFacilityFilters = $('[data-region="clearFacilityFilters"]');
        ui.$mapFilter = $('[data-region="mapFacilityFilters"]');
        ui.$mapFilterToggle = $('[data-region="facilityTypeFilterToggle"]');
        ui.$mapViewType = $('[data-region="viewType"]');
        ui.$mapViewTypes = $('[data-region="viewTypes"]');
        ui.$pagination = $('[data-regon="pagination"]');
        ui.$resultInfo = $('[data-regon="resultinfo"]');
        ui.$searchInput = $('[data-control="searchInput"]');
        ui.$allRegions = $('[data-control="allRegions"]');
        ui.$searchSubmitBtn = $('[data-control="searchSubmit"]');
        ui.$searchWrapper = $('[data-regon="searchWrapper"]');
        
        ui.apiurl = ui.$listingContainer.data('apiurl');
        ui.loader = $('[data-control="pageLoader"]');
        ui.map = document.getElementById("map");
        ui.totalpages = '';
        ui.totalResults = 0;
    }

    function bindEvents() {
        ui.$searchSubmitBtn.on('click', searchClick);
        ui.$filter.on('click', function(e) {
            filterClick(e);
        });
        ui.$searchInput.on('keypress', function(e) {
            if (e.which == 13) {
                searchClick();
            }
        });
        ui.$searchInput.on('change', function(e) {
            if(ui.$searchInput.val() === '') {
                searchParams.searchTerm = '';
            }
        });
        ui.$mapFacility.on('click', function(e) {
            e.preventDefault();
            mapFacilityTypeClick(e);
        });
        ui.$mapViewType.on('click', function(e) {
            e.preventDefault();
            handleChangeViewTypeClick(e);
        });
        ui.$mapFilterToggle.on('click', function(e) {
            e.preventDefault();
            handleMapFilterToggleClick();
        });
        ui.$mapClearFacilityFilters.on('click', function(e) {
            e.preventDefault();
            mapFacilityTypeClick(e);
        });
    }

    function init() {
        if ($('[data-region="locationResults"]').length <= 0) {
            return;
        }
        cacheUI();
        bindEvents();
        showLoader();

        const DefaultView = ui.$mapContainer ? ViewTypes.MapView : ViewTypes.ListView;

        if($(ui.$listingContainer).hasClass('-hidden')) {
            $(ui.$pagination).hide();
        }

        searchParams.region = $('.-active[data-filtercontrol]').attr(
            'data-filtercontrol'
        );
        searchParams.viewType = ui.$listingContainer.attr(
            'data-viewtype'
        );
        
        if (window.location.href.match(/\?./)) {
            const urlParams = new URLSearchParams(
                decodeURIComponent(window.location.search)
            );

            for (const [key, value] of urlParams.entries()) {
                if (key === params.region) {
                    updateFilterRegion(value);
                    searchParams[key] = value;
                } else {
                    searchParams[key] = value;
                }
                if (key === params.searchTerm && value != '') {
                    ui.$searchInput.val(value);
                }
                if (key === params.viewType && value != '') {
                    setViewType(value);
                } else {
                    setViewType(searchParams.viewType);
                }
                if (key === params.facilityType && value != '') {
                    setActiveFacilityTypes(value);
                }
            }
        } else {
            setViewType(DefaultView);
        }
    
        searchParams.pageSize = parseInt(
            $('[data-pageSize]').attr('data-pageSize')
        );
        
        searchParams.allRegions = ui.$allRegions.val();
        getLocationResults(false);
    }

    function updateFilterRegion(region) {
        ui.$filter.removeClass(activeClassName);
        $('[data-filtercontrol="' + region + '"').addClass(activeClassName);
        searchParams.region = $('[data-filtercontrol="' + region + '"').attr(
            'data-filtercontrol'
        );
    }

    function searchClick() {
        showLoader();
        searchParams.searchTerm = ui.$searchInput.val();
        searchParams.pageNum = 1;
        getLocationResults(true);
    }

    function filterClick(e) {
        showLoader();
        let currentFilter = e.currentTarget;
        let region = 'All';
        if ($(currentFilter).hasClass(activeClassName)) {
            $(currentFilter).removeClass(activeClassName);
        } else {
            ui.$filter.removeClass(activeClassName);
            region = $(currentFilter).attr('data-filtercontrol');
            $(currentFilter).addClass(activeClassName);
        }
        searchParams.pageNum = 1;
        searchParams.region = region;
        getLocationResults(true);
    }

    function setActiveFacilityTypes(facilities) {
        let facilitiesArr = facilities.split(',');
        if(facilitiesArr.length > 0) {
            facilitiesArr.forEach((facility) => {
                $(ui.$mapFacility).filter(`[data-mapfiltercontrol="${facility}"]`).addClass(activeClassName);
            });
        }
    }

    function mapFacilityTypeClick(e) {
        let filterTypeEl = e.currentTarget;
        showLoader();

        if($(filterTypeEl).data('mapfiltercontrol') === 'Clear') { // clear filters
            $(filterTypeEl).addClass(activeClassName);
            searchParams.facilityType = '';
            $(ui.$mapFacility).removeClass(activeClassName);
        } else {
            $(filterTypeEl).toggleClass(activeClassName);
            $(ui.$mapClearFacilityFilters).removeClass(activeClassName);
            let activeFilters = $(ui.$mapFacility).filter(activeClass);
            let facilityTypeStr = '';

            $.each(activeFilters, (index, item) => {
                if(facilityTypeStr !== '') {
                    facilityTypeStr += `,`;
                }
                facilityTypeStr += $(item).data('mapfiltercontrol');
            });
            
            if(facilityTypeStr === '') {
                $(ui.$mapClearFacilityFilters).addClass(activeClassName);
            }

            searchParams.facilityType = facilityTypeStr;
        }
        
        getLocationResults(true);
        updateURLHistory();
    }

    function setViewType(viewType) {
        const viewTypeSelector = `[data-viewtype="${viewType}"]`;
        $(ui.$mapViewType).removeClass(activeClassName);
        $(ui.$mapViewTypes).find(viewTypeSelector).addClass(activeClassName);

        if(viewType == ViewTypes.MapView) {
            $(ui.$mapContainer).show();
            $(ui.$listingContainer).hide();
            $(ui.$pagination).hide();
        } else {
            $(ui.$mapContainer).hide();
            $(ui.$listingContainer).show();
            $(ui.$pagination).show();
        }

        searchParams.viewType = viewType;
    }

    function handleChangeViewTypeClick(e) {
        let viewType = $(e.currentTarget)[0].dataset.viewtype;
        setViewType(viewType);
        getLocationResults(true);
    }

    function handleMapFilterToggleClick() {
        ui.$mapFilter.toggleClass(activeClassName);
    }

    function scrollToTop() {
        let articleCardLink = document.querySelector('.loc-results__item a');
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });

        setTimeout(function() {
            articleCardLink = document.querySelector('.loc-results__item a');
            articleCardLink.focus();
        }, 500);
    }

    function paginationClick(e) {
        let selectedPage = $(e.currentTarget).data('page');
        showLoader();
        searchParams.pageNum = parseInt(selectedPage);
        getLocationResults(true);
        scrollToTop();
    }

    async function getLocationResults(updateURL) {
        let url = ui.apiurl;
        if (process.env.NODE_ENV !== 'development') {
            getLocations.setRoute(url);
        }

        const { success, data, error } = await getLocations.query(searchParams);
        if (!success) {
            console.log('failed', error);
            hideLoader();
            return;
        }
        ui.totalpages = parseInt(data.totalPages);
        ui.totalResults = parseInt(data.totalResults);
        var locationCard = '';
        let updatedAddress;
        locations = data.locations;
        
        $.each(data.locations, function(i, item) {
            let facilities = '';
            if (item.lat.length < 1 && item.lng.length < 1) {
                updatedAddress = item.address;
            } else {
                updatedAddress = `${item.lat}, ${item.lng}`;
            }
            if (item.phone.length < 1) {
                item.phone = '-hidden';
            }
            if(item.facilityType && item.facilityType.length) {
                item.facilityType.forEach(x => {
                    if(x?.name) {
                        facilities += `${templates.facilityPill({facilityType: x.name, facilityColor: x?.color})}`;
                    }                    
                });                             
            }
            locationCard += `${templates.locationItem({
                name: item.name,
                address: item.address,
                phone: item.phone,
                latLong: updatedAddress,
                facilities: facilities,
                thumbnail: item.thumbnail,
            })}`;
        });

        if (searchParams.viewType == ViewTypes.MapView && $(ui.$mapContainer).length > 0) {
            // Only init map when needed
            initMap();
            setViewType(ViewTypes.MapView);
        } else {
            // Only render list view html when needed
            ui.$listingContainer.html(locationCard);
            setViewType(ViewTypes.ListView);
        }
        
        updatePagination(searchParams.pageNum, ui.totalpages);
        if (updateURL) {
            updateURLHistory();
        }
        hideLoader();
        initMap();
    }

    function updateURLHistory() {
        if ('URLSearchParams' in window) {
            var newSearchParams = new URLSearchParams(window.location.search);
            if (searchParams.searchTerm) {
                newSearchParams.set(params.searchTerm, searchParams.searchTerm);
            } else {
                newSearchParams.delete(params.searchTerm);
            }
            if (searchParams.region) {
                newSearchParams.set(params.region, searchParams.region);
            } else {
                newSearchParams.delete(params.region);
            }
            if (searchParams.viewType) {
                newSearchParams.set(params.viewType, searchParams.viewType);
            } else {
                newSearchParams.delete(params.viewType);
            }
            if (searchParams.facilityType) {
                newSearchParams.set(params.facilityType, searchParams.facilityType);
            } else {
                newSearchParams.delete(params.facilityType);
            }
            newSearchParams.set('pageNum', searchParams.pageNum);
            newSearchParams.set('sites', searchParams.sites);
            var newRelativePathQuery =
                window.location.pathname + '?' + newSearchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
    }

    function updatePagination(page, totalPages) {
        let liTag = '';
        let active = '';
        page = parseInt(page);
        let beforePage = page - 1;
        let afterPage = page + 1;

        if (page > 1) {
            liTag += `<li class="page-item"><button data-page="${page -
                1}" class="page-link" aria-label="Previous"><span aria-hidden="true"></span></button></li>`;
        } else if (page == 1) {
            liTag += `<li class="page-item disabled"><button data-page="${page}" class="page-link" disabled="true" aria-label="Previous"><span aria-hidden="true"></span></button></li>`;
        }

        if (page > 2) {
            if (totalPages >= 5) {
                liTag += `<li class="page-item"><button data-page="1" class="page-link"><span>1</span></button></li>`;
            }
            if (page > 3 && totalPages > 5) {
                liTag += `<li class="page-item pagination-bar__dots dots"><span class="page-link">...</span></li>`;
            }
        }
        // how many pages or li show before the current li
        if (page == totalPages) {
            beforePage = beforePage - 2;
        } else if (page == totalPages - 1) {
            beforePage = beforePage - 1;
        }

        if (beforePage < 0) {
            beforePage = 0;
        }
        // how many pages or li show after the current li
        if (page == 1) {
            afterPage = afterPage + 2;
        } else if (page == 2) {
            afterPage = afterPage + 1;
        }
        for (let plength = beforePage; plength <= afterPage; plength++) {
            if (plength > totalPages) {
                //if plength is greater than totalPage length then continue
                continue;
            }
            if (plength == 0) {
                //if plength is 0 than add +1 in plength value
                plength = plength + 1;
            }
            if (page == plength) {
                //if page is equal to plength than assign active string in the active variable
                active = 'active';
            } else {
                //else leave empty to the active variable
                active = '';
            }
            liTag += `<li class="page-item numb ${active}"><button data-page="${plength}" class="page-link"><span>${plength}</span></button></li>`;
        }

        if (page < totalPages - 1) {
            //if page value is less than totalPage value by -1 then show the last li or page
            if (page < totalPages - 2 && totalPages > 5) {
                //if page value is less than totalPage value by -2 then add this (...) before the last li or page
                liTag += `<li class="page-item dots"><span class="page-link">...</span></li>`;
            }
            if (totalPages >= 5) {
                liTag += `<li class="page-item last numb"><button  data-page="${totalPages}" class="page-link"><span>${totalPages}</span></button></li>`;
            }
        }

        if (page <= totalPages) {
            //show the next button if the page value is less than totalPage
            if (page < totalPages) {
                liTag += `<li class="page-item" ><button data-page="${page +
                    1}" class="page-link" aria-label="Next"><span aria-hidden="true"></span></button></li>`;
            } else if (page == totalPages) {
                liTag += `<li class="page-item disabled"><button data-page="${page}" class="page-link" disabled="true" aria-label="Next"><span aria-hidden="true"></span></button></li>`;
            }
        }
        ui.$pagination.html(liTag); //add li tag inside ul tag
        $('.pagination .page-link').each(function() {
            $(this).on('click', paginationClick);
        });
    }

    function showLoader() {
        ui.$searchWrapper.css('opacity', '.3').css('pointer-events', 'none');
        ui.loader.show();
    }

    function hideLoader() {
        ui.$searchWrapper.css('opacity', '1').css('pointer-events', 'all');
        ui.loader.hide();
    }

    function getFacilityTypes(facilityTypes) {
        let facilityTypesHtml = '';
        facilityTypes.map((facilityType) => {
            facilityTypesHtml += `<span>${facilityType.name}</span>`;
        });
        return facilityTypesHtml;
    }

    async function initMap() {
        const { Map, InfoWindow } = await google.maps.importLibrary("maps");
        const { PinElement, AdvancedMarkerElement } = await google.maps.importLibrary("marker");
        if(!document.getElementById("map")) {
            return;
        }
        const map = new google.maps.Map(document.getElementById("map"), {
            zoom: 3,
            maxZoom: 14,
            disableDefaultUI: true,
            center: { lat: 0, lng: 0 },
            // TODO: Sitecore configurable with Bunge's Map ID. It's currently set to my personal Google Maps API account.
            mapId: '2e747d9f99ec7898'
        });

        const infoWindow = new google.maps.InfoWindow({
            content: "",
            disableAutoPan: true,
        });
        const bounds = new google.maps.LatLngBounds()

        // Add some markers to the map.
        if (locations.length > 0) {
            const markers = locations.map((position, i) => {
                let label = `
                    <header class="info-header ${position.facilityType[0]?.color}">
                        <h6>${getFacilityTypes(position.facilityType)}</h6>
                    </header>
                    <div class="info-content ${position.facilityType[0]?.color}-light">
                        <p><strong>${position.name}</strong></p>
                        <p>${position.address}</p>
                        ${position.phone !== '-hidden' ? `<p>${position.phone}</p>` : ''}
                    </div>`;

                const pinTag = document.createElement("div");
                pinTag.className = 'pin';
                if(position.facilityType.length > 0) {
                    let pinColor = position.facilityType[0].color; // set default

                    if(searchParams.facilityType) {
                        // filter by selected facility type
                        pinColor = (position.facilityType).filter((facilityType) => {
                            return (searchParams.facilityType).indexOf(facilityType.name) > -1;
                        });
                        pinTag.className += ` ${pinColor[0].color}`;
                    } else {
                        pinTag.className += ` ${pinColor}`;
                    }
                }

                const marker = new AdvancedMarkerElement({
                    position: new google.maps.LatLng(position.lat, position.lng),
                    content: pinTag,
                    map: map
                });

                bounds.extend(marker.position);

                // markers can only be keyboard focusable when they have click listeners
                // open info window when marker is clicked
                marker.addListener("click", () => {
                    infoWindow.setContent(label);
                    infoWindow.open(map, marker);
                });
                return marker;
            });

            const renderer = {
                render({ count, position }, stats) {
                    const clusterMarker = document.createElement("div");
                    clusterMarker.className = "cluster";
                    const countEl = document.createElement('span');
                    countEl.textContent = count;
                    clusterMarker.append(countEl);
                    const advMarker = new AdvancedMarkerElement({
                        content: clusterMarker,
                        position,
                        // adjust zIndex to be above other markers
                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                    });
                    advMarker.addListener('click', ({domEvent, latLng}) => {
                        if(ui.$mapFilter.hasClass(activeClassName)) {
                            handleMapFilterToggleClick();
                        }
                        setTimeout(() => {
                            map.setZoom(map.getZoom() - 1);
                        }, 50);
                    });
                    return advMarker;
                }
            };

            // Add a marker clusterer to manage the markers.
            const markerCluster = new MarkerClusterer({ map, markers, renderer });

            map.fitBounds(bounds);
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function() {
    Bunge.LocationResults.init();
});